import ApplicationController from "../application_controller";
import { stringToHtmlId } from "../../helpers/util";

function headingLevel(ele: HTMLHeadingElement) {
  return Number(ele.tagName.replace(/[\D]/g, ""));
}

function uniqueHeadingIds(headingIds: Array<string>) {
  const uniqueIds = new Set();
  return headingIds.map((id) => {
    let uniqueId = id;
    let i = 1;
    while (uniqueIds.has(uniqueId)) {
      uniqueId = `${id}-${i}`;
      i += 1;
    }
    uniqueIds.add(uniqueId);
    return uniqueId;
  });
}

export default class TocController extends ApplicationController {
  static targets = ["toc", "body", "tocItemTemplate"];

  declare readonly tocTarget: HTMLElement;
  declare readonly bodyTarget: HTMLElement;
  declare readonly tocItemTemplateTarget: HTMLTemplateElement;

  connect() {
    this.buildToc();
  }

  buildToc() {
    const headingElements = [...this.bodyTarget.querySelectorAll<HTMLHeadingElement>("h1, h2, h3, h4, h5, h6")];
    if (!headingElements.length) return;
    const topLevelHeading = Math.min(...headingElements.map((ele) => headingLevel(ele)));
    const topLevelHeadings = headingElements.filter((ele) => headingLevel(ele) === topLevelHeading);
    const headingIds = uniqueHeadingIds(topLevelHeadings.map((ele) => stringToHtmlId(ele.textContent!)));
    this.tocTarget.innerHTML = "";
    topLevelHeadings.forEach((ele, i) => {
      ele.id = headingIds[i];

      const listElement = document.importNode(this.tocItemTemplateTarget.content, true);
      const linkElement = listElement.querySelector("a") as HTMLAnchorElement;
      linkElement.href = `#${ele.id}`;
      linkElement.textContent = ele.innerText;
      this.tocTarget.appendChild(listElement);
    });
  }
}
